export enum OrderAmountUnit {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    generalPieces,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    generalHours
}